import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from "@mui/icons-material";
import { CircularProgress, Link, Stack, Typography } from "@mui/material";

interface IProps {
    isLoading: boolean;
    isError: boolean;
}

export const FinalizePartnerApplication: React.FC<IProps> = ({ isLoading, isError }) => {
    if (isLoading) {
        return (
            <Stack alignItems="center" spacing={4} py={8}>
                <CircularProgress />
                <Typography align="center">
                    Reviewing your application. This should take no more than 60 seconds.
                </Typography>
            </Stack>
        );
    }

    if (isError) {
        return (
            <Stack alignItems="center" spacing={4} py={8}>
                <ErrorIcon color="disabled" sx={{ fontSize: 60 }} />
                <Typography align="center">
                    There was an error submitting your application. Please reach out to us at{" "}
                    <Link href="mailto:support@levro.com" target="_blank" rel="noreferrer">
                        support@levro.com
                    </Link>{" "}
                    to complete your application.
                </Typography>
            </Stack>
        );
    }

    return (
        <Stack alignItems="center" spacing={4} py={8}>
            <CheckCircleIcon color="success" sx={{ fontSize: 60 }} />
            <Typography fontWeight="bold" align="center">
                Application Submitted
            </Typography>
            <Typography align="justify">
                Your application has been submitted, we are redirecting you to set a password for your account.
            </Typography>
        </Stack>
    );
};
